import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { Field } from '@/shared/api/rest/models';
import ButtonWithArrow from '@/shared/components/buttons/ButtonWithArrow.vue';
import store from '@/store';

import FormFieldSetEditFields from './FormFieldSetEditFields.vue';

/* PROPS */

export default /*#__PURE__*/_defineComponent({
  __name: 'EditFieldsSidebar',
  props: {
    fieldIds: null,
    columns: null,
    invalidEditFields: null,
    errorMessage: null,
    uniqueNameViolation: { type: Boolean },
    geoDataChanges: null
  },
  emits: ['closeEditMode', 'save:editedFields'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  fieldIds: string[];
  columns: any;
  invalidEditFields: Field[];
  errorMessage?: string;
  uniqueNameViolation: boolean;
  geoDataChanges: any;
}



/* COMPUTED */
const fields = computed<Field[]>(() => props.fieldIds.map((id) => store.state.fields.data[id]));

/* STATE */
const changes: any = ref({});
const missingName = ref<boolean | null>(null);

/* EMITS */


/* METHODS */
function save() {
  if (props.invalidEditFields.length > 0) {
    return;
  }

  if (typeof changes.value.name === 'string' && changes.value.name.length === 0) {
    missingName.value = true;
    return;
  }

  emit('save:editedFields', props.fieldIds, changes.value);
}

function closeEditMode() {
  changes.value = {};
  emit('closeEditMode');
}

/* EXPOSES */
expose({ save });

return { __sfc: true,props, fields, changes, missingName, emit, save, closeEditMode, ButtonWithArrow, FormFieldSetEditFields }
}

})